import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

import { Typography } from "@mui/material";

import { RHFCheckbox, Section, OneColumnStack } from "@arp/react-ndbx";

//* Config
import { policyOutcomeFieldNames } from "../../../config/pageInfo/pageFieldName.js";
import { policyOutcomeDisclaimers } from "../../../config/disclaimers/disclaimers.jsx";

import NotificationCard from "../../coding/notificationCard/NotificationCard.jsx";

//----------------------------------------------------------------

const displayCheckBox = (isOnLine, person, maxWidth, setMargin, dataSet) => {
	// const labelAria = { inputProps: { "aria-label": `${name}-checkbox` } };

	return (
		<OneColumnStack
			maxWidth={maxWidth}
			mt={2}
			ml={setMargin}
			sx={{ border: "0px solid red" }}
		>
			<RHFCheckbox
				label={
					policyOutcomeDisclaimers({
						isOnline: isOnLine,
					}).policyOutcomeInfo[0].TERMS_AND_CONDITIONS.note
				}
				defaultChecked={dataSet?.policyOutcomeAcceptTerms || false}
				name={policyOutcomeFieldNames(person).ACCEPT_OFFER}
			></RHFCheckbox>
		</OneColumnStack>
	);
};

const displayContactCenterCheckBox = (
	isOnLine,
	person,
	maxWidth,
	setMargin,
	dataSet,
	reset,
	parentOnChange,
	isUW = false
) => {
	const {
		methods: [methods],
	} = useOutletContext();
	const { trigger, setValue } = { ...methods };

	const [isChecked, setIsChecked] = useState(dataSet?.policyOutcomeAcceptTerms);

	const handleOnClick = () => {
		setIsChecked((prev) => !prev);
	};

	useEffect(() => {
		setIsChecked((prev) => !prev);
	}, [reset]);

	useEffect(() => {
		setValue(policyOutcomeFieldNames(person).ACCEPT_OFFER, isChecked, {
			shouldDirty: !isChecked,
		});
		trigger();

		if (isUW === true) {
			parentOnChange(isChecked);
		}
	}, [isChecked]);

	return (
		<OneColumnStack
			maxWidth={maxWidth}
			mt={2}
			ml={setMargin}
			sx={{ border: "0px solid red" }}
		>
			<RHFCheckbox
				label={
					policyOutcomeDisclaimers({
						isOnline: isOnLine,
					}).policyOutcomeInfo[0].TERMS_AND_CONDITIONS.note
				}
				defaultChecked={isChecked}
				onChange={handleOnClick}
				checked={isChecked}
				name={policyOutcomeFieldNames(person).ACCEPT_OFFER}
			></RHFCheckbox>
		</OneColumnStack>
	);
};

export default function OutcomeTermsAndConditions(props) {
	const {
		showSpecialTerms,
		onLine = true,
		person = "personOne",
		dataSet,
		setValue,
		handleSubmit,
		reset,
		parentOnChange,
		isUW = false,
	} = { ...props };

	useEffect(() => {
		const termsAccepted = dataSet?.policyOutcomeAcceptTerms;
		setValue("acceptOffer", termsAccepted, {
			shouldDirty: termsAccepted,
		});
		handleSubmit(() => {})();
	}, []);

	return (
		<>
			{showSpecialTerms === true ? (
				<>
					{onLine === false ? (
						<Section mt={4} xs={12} md={10} lg={7} sx={{ textAlign: "left" }}>
							<Typography variant="p3">
								{
									policyOutcomeDisclaimers({
										isOnline: onLine,
									}).policyOutcomeInfo[0].TERMS_CONDITION_WITH_EXCLUSION.note
								}
							</Typography>
							{displayContactCenterCheckBox(
								onLine,
								person,
								"fit-content",
								0,
								dataSet,
								reset,
								parentOnChange,
								isUW
							)}
						</Section>
					) : (
						<>
							<OneColumnStack maxWidth="670px">
								<NotificationCard
									cardType="info"
									title=""
									alignIcon="flex-start"
									message={
										policyOutcomeDisclaimers({
											isOnline: onLine,
										}).policyOutcomeInfo[0].TERMS_CONDITION_WITH_EXCLUSION.note
									}
								/>
							</OneColumnStack>
							{displayCheckBox(onLine, person, 670, 0, dataSet)}
						</>
					)}
				</>
			) : (
				<Section mt={4} xs={12} md={10} lg={7} sx={{ textAlign: "left" }}>
					<Typography variant="p3">
						{
							policyOutcomeDisclaimers({
								isOnline: onLine,
							}).policyOutcomeInfo[0].TERMS_CONDITION_NO_EXCLUSION.note
						}
					</Typography>
				</Section>
			)}
		</>
	);
}
